import { IModel, Model, ModelRecord } from '@common/models/Model';

export interface IProactivePrescriptionRuleItemModel extends IModel {
  proactivePrescriptionRuleItemId: number;
  proactivePrescriptionRuleId: number;
  salesItemOptionId: number;
  businessLineId: number;
}

export class ProactivePrescriptionRuleItemModel
  extends Model
  implements ModelRecord<IProactivePrescriptionRuleItemModel>
{
  proactivePrescriptionRuleItemId: number;
  proactivePrescriptionRuleId: number;
  salesItemOptionId: number;
  businessLineId: number;

  constructor(params?: Partial<IProactivePrescriptionRuleItemModel>) {
    super(params);
    this.proactivePrescriptionRuleItemId =
      params?.proactivePrescriptionRuleItemId || 0;
    this.proactivePrescriptionRuleId = params?.proactivePrescriptionRuleId || 0;
    this.salesItemOptionId = params?.salesItemOptionId || 0;
    this.businessLineId = params?.businessLineId || 0;
  }
}
